export const container = `
  group/color-icon w-full text-sm flex gap-2 items-center justify-between
`;
export const caret = `w-2.5 h-2.5 shrink-0 group-data-[is-active="true"]/categories-toggle-score:rotate-180 transition-transform duration-50 ease-in-out`;
export const title = `flex grow gap-1 items-center  overflow-hidden truncate whitespace-nowrap`;
export const text = `text-nowrap text-gray-400 font-medium -mt-0.5`;
